
<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                Reprots
            </h1>
        </div>
        <div class="card">
            <div class="col-sm-12 mt-2 mb-2">
                <div class="row ">
                    <div class="col-sm-2 mt-2  mb-2" >
                        <mat-select  placeholder="Duration" (selectionChange)="getLeadReport();getOpdReport();getIpdReport()" [(ngModel)]="duration">
                            <mat-option value="all" >All Time</mat-option>
                            <mat-option value="2020" >2020</mat-option>
                            <mat-option value="2021" >2021</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2  mb-2" *ngIf="myrole=='1'">
                        <mat-select  placeholder="Circle" (selectionChange)="getLeadReport();getOpdReport();getIpdReport()" [(ngModel)]="circle">
                            <mat-option >All</mat-option>
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
        </div>
        
            <div class="row">
                <div class="col-sm-6">
                    <h3>Lead Chart</h3>
                    <div class="card">
                        <div class="chart-wrapper">
                            <canvas baseChart 
                                [datasets]="barChartData"
                                [labels]="barChartLabels"
                                [options]="barChartOptions"
                                [plugins]="barChartPlugins"
                                [legend]="barChartLegend"
                                [colors] = "color"
                                [chartType]="barChartType">
                            </canvas>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <h3>Opd Chart</h3>
                    <div class="card">
                        <div class="chart-wrapper">
                            <canvas baseChart #Opdchart 
                                [datasets]="barChartDataOpd"
                                [labels]="barChartLabelsOpd"
                                [options]="barChartOptions"
                                [plugins]="barChartPlugins"
                                [legend]="barChartLegend"
                                [colors] = "color"
                                [chartType]="barChartType">
                            </canvas>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <h3>Ipd Chart</h3>
                    <div class="card">
                        <div class="chart-wrapper">
                            <canvas baseChart 
                                [datasets]="barChartDataIpd"
                                [labels]="barChartLabelsIpd"
                                [options]="barChartOptions"
                                [plugins]="barChartPlugins"
                                [legend]="barChartLegend"
                                [colors] = "color"
                                [chartType]="barChartType">
                            </canvas>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>